import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import DataService from "../../../../../Service";
import MasterTemplateDrawer from "./MasterTemplateDrawer";
import {
  Box,
  Input,
  InputAdornment,
  InputBase,
  TextField,
  Tooltip,
} from "@material-ui/core";
import MasterTemplateModal from "../MasterTemplate/MasterTemplateModal";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Button from "@material-ui/core/Button";
import { useLocation } from "react-router";
import SearchIcon from "@material-ui/icons/Search";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import { Autocomplete } from "@material-ui/lab";
import SetupAutoComplete from "../SetupAutoComplete";

const useStyles = makeStyles((theme) => ({
  buttonShadow: {
    textTransform: "inherit",
  },

  miTablebox: {
    "& .MuiFormControl-root": {
      width: "25%",
    },
  },
  tooltipMaxWidth: {
    maxWidth: "450px",
  },
  tooltipMinWidth: {
    maxWidth: "300px",
  },
}));

export default function SimpleAction(props) {
  const classes = useStyles();
  const [currentSelection, setCurrentSelection] = useState({});
  const [action, setAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [apiTemplateData, setApiTemplateData] = useState([]);
  const [modal, setModal] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [headerInputValue, setHeaderInputValue] = useState("");
  const [masterPage, setMasterPage] = useState(0);
  const [masterPageSize, setMasterPageSize] = useState(20);
  const [totalMasterCount, setTotalMasterCount] = useState(100);
  const [stepperData, setStepperData] = useState(undefined);
  const [headerType, setHeaderType] = useState(undefined);
  const [headerModal, setHeaderModal] = useState("");
  const [fetchApiFlag, setFetchApiFlag] = useState(false);
  const [headerName, setHeaderName] = useState("");
  const [dropDownValue, setDropDownValue] = useState(undefined);

  const currentRoute = useLocation();

  useEffect(() => {
    getData();
  }, [masterPageSize, masterPage, searchText, fetchApiFlag]);

  const getData = () => {
    setLoading(true);
    const params = {
      page: masterPage + 1 || 1,
      count_per_page: masterPageSize || 20,
      search_keyword: searchText || " ",
    };
    DataService.getData(params, "fetchMasterTemplateList")
      .then((response) => {
        if (response?.["success"]) {
          let listData = response["master_templates"];
          setApiTemplateData(listData);
          setTotalMasterCount(response?.total_count);
          setLoading(false);
        } else {
          setApiTemplateData([]);
          setLoading(false);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    setAction("");
  }, [currentRoute.key]);
  const searchSelectHandler = (option) => {
    setSearchText(option);
    setMasterPage(0);
  };
  return (
    <Box mb={3}>
      <SetupAutoComplete
        type="master_templates"
        searchSelectHandler={searchSelectHandler}
      />
      <MaterialTable
        title=""
        options={{
          actionsColumnIndex: -1,
          searchFieldAlignment: "right",
          pageSize: masterPageSize,
          total: totalMasterCount,
          emptyRowsWhenPaging: false,
          search: false,
          headerStyle: {
            fontWeight: 700,
            color: "#077F83",
            position: "sticky",
            top: "0",
          },
          maxBodyHeight: "600px",
          pageSizeOptions: [20, 50, 75, 100],
        }}
        columns={[
          {
            title: "Name",
            field: "template_name",
            headerStyle: {
              fontWeight: 700,
              paddingLeft: 28,
            },
            cellStyle: {
              paddingLeft: 28,
            },
            customSort: (a, b) => {
              const nameA = a.template_name.toLowerCase();
              const nameB = b.template_name.toLowerCase();

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            },
          },
        ]}
        data={apiTemplateData}
        totalCount={totalMasterCount}
        page={masterPage}
        onRowClick={(e, rowData) => {
          setCurrentSelection(rowData);
        }}
        onChangePage={(page) => {
          setMasterPage(page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          setMasterPageSize(pageSize);
        }}
        onSearchChange={(search) => {
          setSearchText(search);
        }}
        actions={[
          {
            icon: () => <VisibilityIcon fontSize="small" />,
            tooltip: <TooltipWrapper text="View" />,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              setAction("view");
            },
          },
          // {
          //   icon: () =>
          //     <TextField variant="outlined" style={{
          //       position: 'absolute',
          //       left: '-44rem',
          //       top: '1px', width: '200px'
          //     }}
          //       InputProps={{
          //         startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
          //       }}
          //       type="search"
          //       value={searchText}
          //       placeholder="Search"

          //       onInput={(event) => setSearchText(event.target.value)}
          //     > </TextField>,
          //   // tooltip: "Search",
          //   isFreeAction: true,
          // },
          {
            icon: () => <EditIcon fontSize="small" />,
            tooltip: <TooltipWrapper text="Edit" />,
            onClick: (event, rowData) => {
              setCurrentSelection(rowData);
              setInputValue(rowData?.template_name);
              setModal(true);
            },
          },
          {
            icon: () => (
              <Button
                className={classes.buttonShadow}
                variant="contained"
                color="secondary"
              >
                + New program master template
              </Button>
            ),
            isFreeAction: true,
            onClick: (event) => {
              setCurrentSelection("");
              setInputValue("");
              setDropDownValue({});
              setModal(true);
            },
          },
        ]}
      />
      {action === "view" && (
        <MasterTemplateDrawer
          setStepperData={setStepperData}
          stepperData={stepperData}
          setHeaderModal={setHeaderModal}
          headerModal={headerModal}
          headerType={headerType}
          setHeaderType={setHeaderType}
          setHeaderInputValue={setHeaderInputValue}
          headerInputValue={headerInputValue}
          headerName={headerName}
          setHeaderName={setHeaderName}
          onClose={() => {
            setModal(false);
          }}
          fetchApiFlag={fetchApiFlag}
          setFetchApiFlag={setFetchApiFlag}
          handleClose={() => {
            setAction("");
            setCurrentSelection(undefined);
          }}
          currentSelection={currentSelection || ""}
        />
      )}

      {modal && (
        <MasterTemplateModal
          currentSelection={currentSelection || ""}
          fetchMasterTemplate={getData}
          isOpen={modal}
          inputValue={inputValue}
          setInputValue={setInputValue}
          dropDownValue={dropDownValue}
          setDropDownValue={setDropDownValue}
          onClose={() => {
            setModal(false);
          }}
          {...props}
        />
      )}
    </Box>
  );
}
